/* eslint-disable camelcase */
// https://github.com/aws-amplify/amplify-js/blob/main/packages/core/src/Signer.ts

function escape_RFC3986(component) {
  return component.replace(/[!'()*]/g, c => `%${c.charCodeAt(0).toString(16).toUpperCase()}`);
}
export function canonical_query(query) {
  if (!query || query.length === 0) {
    return '';
  }
  return query.split('&').map(e => {
    const key_val = e.split('=');
    if (key_val.length === 1) {
      return e;
    }
    const reEncoded_val = escape_RFC3986(key_val[1]);
    return `${key_val[0]}=${reEncoded_val}`;
  }).sort((a, b) => {
    const key_a = a.split('=')[0];
    const key_b = b.split('=')[0];
    if (key_a === key_b) {
      return a < b ? -1 : 1;
    }
    return key_a < key_b ? -1 : 1;
  }).join('&');
}
function canonical_headers(headers) {
  if (!headers || Object.keys(headers).length === 0) {
    return '';
  }
  return `${Object.keys(headers).map(key => ({
    key: key.toLowerCase(),
    value: headers[key] ? headers[key].trim().replace(/\s+/g, ' ') : ''
  })).sort((a, b) => a.key < b.key ? -1 : 1).map(item => `${item.key}:${item.value}`).join('\n')}\n`;
}
function signed_headers(headers) {
  return Object.keys(headers).map(key => key.toLowerCase()).sort().join(';');
}
export function canonical_request(request) {
  const url_info = new URL(request.url);
  return [request.method || '/', encodeURIComponent(url_info.pathname).replace(/%2F/gi, '/'), canonical_query(url_info.searchParams.toString()), canonical_headers(request.headers), signed_headers(request.headers), request.data].join('\n');
}
export function formatDate(now) {
  const longDate = new Date(now).toISOString().replace(/\.\d{3}Z$/, 'Z').replace(/[-:]/g, '');
  return {
    longDate,
    shortDate: longDate.substr(0, 8)
  };
}
export function generateCredentialScope(d_str, region, service) {
  return [d_str, region, service, 'aws4_request'].join('/');
}